import Parse from 'parse'
import { userModule } from '@/store/user/module'
import type { Study } from '@pocketprep/types'
import type { ClientExam } from '@/store/bundle/state'

const userInitial = () => {
    const user = userModule.state.user
    if (!user) {
        return ''
    }

    return user.firstName
        ? user.firstName.substring(0, 1)
        : user.email.substring(0, 1)
}

const userFullName = () => {
    const user = userModule.state.user
    if (!user) {
        return ''
    }

    return user.firstName
        ? `${user.firstName} ${user.lastName}`
        : user.email.split('@')[0]
}

const getReferralInfo = () => {
    return userModule.state.referralInfo
}

const getUserDomain = () => {
    const user = userModule.state.user
    if (!user?.email) {
        return ''
    }
    return user.email.split('@')[1]
}

const getCurrentOrganizationId = () => {
    const user = userModule.state.user
    if (!user?.currentOrganization) {
        return null
    }
    return user.currentOrganization.objectId
}

/**
 * Returns true if user has seen the given message name for their current exam
 */
const getHasSeenMessage = (messageName: Study.Class.MessageName, exam: Study.Class.ExamMetadataJSON | ClientExam) => {
    const user = userModule.state.user

    if (!user || !exam) {
        return false
    }

    const seenMessage = user.webConfig?.messagesSeen?.find(message =>
        message.name === messageName
        && message.examMetadataId === exam.objectId
        && message.version === exam.version
    )

    return !!seenMessage
}

/** Retrieves the current user's session token from Parse, if current user exists */
const getSessionToken = () => {
    return Parse.User.current()?.getSessionToken()
}

const getCrossPlatformConfig = () => {
    return userModule.state.user?.crossPlatformConfig
}

export default {
    userInitial,
    userFullName,
    getReferralInfo,
    getUserDomain,
    getCurrentOrganizationId,
    getHasSeenMessage,
    getSessionToken,
    getCrossPlatformConfig,
}
